import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TinymceDirective } from './tinymce/tinymce.directive';
import { SharedService } from './shared.service';
import { BasicFunctionsComponent } from './basic.functions';
import { ImageUploadComponent } from './image.upload';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule } from '@ngx-translate/core';
// import { ImageCropperModule } from 'ng2-img-cropper';

import { ImageCropperModule } from 'ngx-image-cropper';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, '../../assets/i18n', '.json');
}


@NgModule({
  declarations: [TinymceDirective, BasicFunctionsComponent, ImageUploadComponent],
  providers: [SharedService],
  imports: [CommonModule,  TranslateModule.forRoot(), ImageCropperModule],
  exports: [CommonModule, FormsModule, NgbModule, TinymceDirective, ImageUploadComponent]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts